var mainImage = document.querySelector('[data-main-image]');
var subImages = document.querySelectorAll('.woocommerce-product-gallery__image a');

function swapImage(image) {
  var subImage = image.querySelector('img');
  var targetSrc = subImage.getAttribute('data-src');
  var targetAlt = subImage.getAttribute('alt');
  mainImage.setAttribute('src', targetSrc);
  mainImage.setAttribute('alt', targetAlt);
}

subImages.forEach(function (image) {
  image.addEventListener('click', function (e) {
    e.preventDefault();
    swapImage(image);
  });
});